'use strict';
import {Injectable, Inject} from 'ng-metadata/core';
import {MappingTablesCache} from '../../mappingTablesCache/mappingTablesCache.service';
import {getEnableEmailClient, getVid} from '../../appConfig/appConfigForward';
import {EndNoteService} from "./endNoteAction/endNote.service";
import {PrintItemService} from "./printAction/printItem.service";
import {EasyBibService} from "./easyBibAction/easyBib.service";
import {RefWorksService} from "./refworksAction/refworks.service";
import {MendeleyService} from "./mendeleyAction/mendeley.service";
import {LegantoService} from "./legantoAction/leganto.service";
import {CMIntegrationService} from "../../cm_integration.service";
import {EmailClientService} from "./sendEmailAction/emailClient.service";

const orderBy = require('lodash/orderBy');

@Injectable()
export class ActionListService {

    private actionsToDisplay: string[] = ['E-mail', 'Print', 'Permalink', 'Citation', 'EasyBib', 'EndNote', 'RefWorks', 'RISPushTo', 'BibTeXPushTo', 'Mendeley', 'Leganto', 'Excel', 'QR' , 'Share'];

    // a list of actions that will not work on the campusM PI - so we hide them
    private cmImtegrationUnsupportedActions: string[] = ['RISPushTo','Print','BibTeXPushTo'];
    private _requiredActionsList: string[] = [];
    private _actionsToIndex: Object = {'none': 0}; // a map from each action to its index in the action tabs. 'none' means all tabs closed

    /*Actions which open a new window must be set in this object so that the window can be opened as an immediate result to the click on the up-front actions and actions list.
     Otherwise the popup blocker will prevent the window from opening*/
    public onToggle = {
        'Print': (item, selectedIds) => {
            this.printItemService.printItemAction(item, selectedIds)
        },
        'RefWorks': (item, selectedIds) => {
            this.refWorksService.refworksAction(item, selectedIds)
        },
        'EasyBib': (item, selectedIds) => {
            this.easyBibService.easyBibAction(item, selectedIds)
        },
        'EndNote': (item, selectedIds) => {
            this.endNoteService.endNoteAction(item, selectedIds)
        },
        'Mendeley': (item, selectedIds) => {
            this.mendeleyService.mendeleyAction(item, selectedIds)
        },
        'Leganto': (item, selectedIds) => {
            return this.legantoService.legantoAction(item, selectedIds)
        }
    };


    constructor(private mappingTablesCache: MappingTablesCache,
                private endNoteService: EndNoteService,
                private printItemService: PrintItemService,
                private easyBibService: EasyBibService,
                private refWorksService: RefWorksService,
                private mendeleyService: MendeleyService,
                private legantoService: LegantoService,
                private cmIntegrationService: CMIntegrationService,
                private emailClient: EmailClientService) {
        this.setRequiredActionsList();
        if(getEnableEmailClient())
            this.onToggle['E-mail'] = (item) => {
                this.emailClient.emailAction(item)
            }
    }

    private setRequiredActionsList() {
        let actionsListUnfiltered = orderBy(this.mappingTablesCache.getTable('Actions List'), (val) => parseInt(val['source2']), 'desc');
        let actionsListUnfilteredMyView = actionsListUnfiltered.filter((val) => val['target'] === getVid());
        actionsListUnfiltered = actionsListUnfilteredMyView.length ? actionsListUnfilteredMyView :
            actionsListUnfiltered.filter((val) => val['target'] === 'default');
        actionsListUnfiltered = actionsListUnfiltered.map((config) => config.source1);
        // We need to display only specific actions. Please notice that there are additional filters on the action list but this is the most basic one.
        this._requiredActionsList = actionsListUnfiltered.filter((actionName) => (this.actionsToDisplay.indexOf(actionName) !== -1));
        if(this.cmIntegrationService.isEnabled()){
            this._requiredActionsList = this._requiredActionsList.filter((actionName) => (this.cmImtegrationUnsupportedActions.indexOf(actionName) === -1));
        }
        for (let i = 0; i < this._requiredActionsList.length; i++) {
            this._actionsToIndex[this._requiredActionsList[i]] = i + 1;
        }
    }

    get requiredActionsList() {
        return this._requiredActionsList;
    }

    get actionsToIndex() {
        return this._actionsToIndex;
    }

    public isActionEnabled(actionName) {
        return this._requiredActionsList.indexOf(actionName) > -1;
    }


}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/actionList.service.ts